<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="3" viewBox="0 0 14 3">
    <line class="a" :class="{red, green}" x2="14" transform="translate(0 1.5)"/>
  </svg>
</template>

<script>
export default {
  name: "NoTrendIcon",
  props: {
    green: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.a {
  fill: none;
  stroke: #707070;
  stroke-width: 3px;

  &.red {
    stroke: #dd227b;
  }

  &.green {
    stroke: #57b98f;
  }

}
</style>
